import "./ChimneyScaffolding.module.css";
import Header from "@/reusable_sections/Header";
import ChimneyScaffolding from "./sections/ChimneyScaffolding";
import RelatedServices from "./sections/RelatedServices";
import Footer from "@/reusable_sections/Footer";
export default function ChimneyScaffoldingPage() {
  return <div>
      <Header />
      <ChimneyScaffolding />
      <RelatedServices />
      <Footer />
    </div>;
}